import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon, IStackTokens, Toggle, ComboBox, IComboBoxOption, IComboBox, TextField, IContextualMenuItem, DetailsList, SelectionMode, DetailsListLayoutMode, ISelection, MarqueeSelection } from '@fluentui/react';
import React, { FormEvent } from 'react';
import { TProduct, TSet } from '../constants/types';
import PokemonCards from './cardsComponent';
import Globals, { IsNull } from '../services/Globals';
import styles from '../styles/pokemon.module.scss';
import { NumberLiteralType } from 'typescript';

export interface ILogsProps {
    dev: boolean;
    apiUrl: string;
    username: string;
    token: string;
    site: string;
}

export interface ILogsState {
    logs: Log[];
    name: string;
    when: string;
    content : string;
    containsCriticalError: boolean;
};

class Log {
    name: string;
    when?: Date;
    content: string;
}

export default class Logs extends React.Component<ILogsProps, ILogsState> {
    constructor(props: ILogsProps) {
        super(props);
        this.GetLogs();
        this.state = {logs: [], name: "", when: "", content: "", containsCriticalError: false};
    }

    private GetLogs() {
        fetch(`${this.props.apiUrl}/Logs?username=${this.props.username}&token=${this.props.token}&site=${this.props.site}`, {
            method: 'GET',
            mode: 'cors',
        }).then((response) => response.json()).then((data : Log[]) => { 
            data.forEach(d=> {
                d.name = d.name.split('/').pop();
                let nameParts = d.name.split('_');
                if (nameParts.length == 3) {
                    let buf = nameParts[1].substring(0,4)+"-"+
                                                 nameParts[1].substring(4,6)+"-"+
                                                 nameParts[1].substring(6,8)+"T"+
                                                 nameParts[2].split('.')[0].substring(0,2)+":"+
                                                 nameParts[2].split('.')[0].substring(2,4)+":"+
                                                 nameParts[2].split('.')[0].substring(4,6);
                    d.when = new Date(Date.parse(buf));
                }
            })
            //data.sort((a,b) => a.when > b.when ? -1 : 1);
            this.setState({logs: data});
        }).catch( err => {
            console.log(err);
        });
    }

    public render(): React.ReactElement<ILogsProps> {
        console.log(this.state);
        return (  
            <div>
                <Stack horizontal>
                    <Stack>
                        {this.state?.logs?.map(l => {
                            return <Stack horizontal style={{marginTop:10,maxWidth:300}}>
                                       <PrimaryButton text={`${l.name} ${l.when ? l.when.toLocaleDateString() : ""} ${l.when ? l.when.toLocaleTimeString() : ""}`} style={{width:"100%"}} onClick={()=>{ this.setState({containsCriticalError: false, 
                                                                                                                                             content: l.content, 
                                                                                                                                             name: l.name, 
                                                                                                                                             when: l.when?.toString().replace('T',' ')})}}/>
                                   </Stack>
                        })}
                    </Stack>
                    {this.state.content && <Stack style={{paddingLeft:10,overflow:"scroll", maxHeight:window.innerHeight-100}}>
                                                {this.state.containsCriticalError ? <h1 style={{color:"red"}}>Contains critical error</h1>:<></>}
                                                <h2>{this.state.name} {this.state.when ? this.state.when : ""}</h2>
                                                {this.state.content.split('\n').map(line=> {
                                                    let pline="";
                                                    if (line.indexOf("[93m") != -1) {
                                                        return <span style={{color:"red",whiteSpace:"nowrap"}}>{line.replace("[93m","")}</span>
                                                    } else if (line.indexOf("[92m") != -1) {
                                                        return <span style={{color:"green",whiteSpace:"nowrap"}}>{line.replace("[92m","")}</span>
                                                    } else if (line.startsWith("Failed to")) {
                                                        return <span style={{color:"orange",whiteSpace:"nowrap"}}>{line.replace("[92m","")}</span>
                                                    } else if (line.indexOf("[ERROR]") != -1) {
                                                        this.setState({containsCriticalError:true});
                                                        return <h2 style={{color:"red",whiteSpace:"nowrap"}}>{line.replace("[92m","")}</h2>
                                                    }
                                                    else {
                                                        return <span style={{whiteSpace:"nowrap"}}>{line}</span>
                                                    }
                                                })}
                                            </Stack>}
                </Stack>
            </div> 
        );
    }
}